/* eslint-disable no-return-await */
import { memedReceita, apiMemed } from './api';

interface ChangePasswordInterface {
  password: string;
  rememberToken: string;
}

export const changePassword = async (paramRequest: ChangePasswordInterface): Promise<any> => {
  return await memedReceita.post(`/reset-password`, paramRequest, {
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
  });
};

interface EmailRecoveryInterface {
  email: string;
  url: string;
}

export const sendEmailRecoverry = async (paramRequest: EmailRecoveryInterface): Promise<any> => {
  return await apiMemed.post(`/forgot-password`, paramRequest);
};
